export default __webpack_public_path__ + "static/media/downArrow.3e92e8ef.svg";